import axios from '@/axios';

export default {
    getData(options) {
        return axios.get(`/qurban`, options);
    },
    getDetail(id, options) {
        return axios.get(`/qurban/${id}`, options);
    },
    getTrackingResult(options) {
        return axios.get(`/tracking-qurban`, options);
    }
};